import intl from "react-intl-universal";
import { SummaryCardSkeleton } from "../../../../Components/Molecules/DashboardSkeleton";
import { formatBrl } from "../constants";
import { CurrencyBalanceCard } from "./CurrencyBalanceCard";

export const ContaInternacionalBalanceCards = ({
  currencies = [],
  totalBrl = 0,
  loading = false,
  usingFallback = false,
  error = null,
  onViewAllCurrencies,
  onRetry,
}) => {
  const isInitialLoading = loading && !currencies.length;

  return (
    <section className="balance-cards-panel mb-6 min-w-0 w-full">
      <div className="mb-3 flex flex-wrap items-center justify-between gap-x-3 gap-y-2">
        <div className="flex min-w-0 flex-wrap items-center gap-2">
          <h2 className="text-sm font-bold text-brand-dark">
            {intl.get("contaInternacional.balanceSection")}
          </h2>
          {usingFallback && !loading ? (
            <span
              className="inline-flex max-w-full items-center rounded-md border border-amber-200/70 bg-amber-50/70 px-2 py-0.5 text-[10px] font-medium leading-snug text-amber-800/80 dark:border-amber-500/30 dark:bg-amber-500/10 dark:text-amber-300/90"
              title={intl.get("contaInternacional.quotesFallbackHint")}
            >
              {intl.get("contaInternacional.quotesFallbackHint")}
            </span>
          ) : null}
        </div>
        <p className="shrink-0 text-xs text-gray-500">
          {intl.get("contaInternacional.totalApproxLabel")}{" "}
          {loading ? (
            <span className="inline-block h-3.5 w-24 animate-pulse rounded bg-gray-200 align-middle dark:bg-gray-700" />
          ) : (
            <span className="font-semibold text-brand-dark">{formatBrl(totalBrl)}</span>
          )}
        </p>
      </div>

      {error && !loading ? (
        <p className="mb-3 text-xs text-red-600 dark:text-red-400">
          {intl.get("contaInternacional.balancesLoadError")}
          {typeof onRetry === "function" ? (
            <>
              {" "}
              <button
                type="button"
                className="underline font-medium"
                onClick={onRetry}
              >
                {intl.get("contaInternacional.retryLoad")}
              </button>
            </>
          ) : null}
        </p>
      ) : null}

      <div className="balance-cards-scroll-row">
        {isInitialLoading
          ? Array.from({ length: 4 }).map((_, index) => (
              <SummaryCardSkeleton key={index} />
            ))
          : currencies.length
            ? currencies.map((currency) => (
                <CurrencyBalanceCard
                  key={currency.id}
                  currency={currency}
                  loadingRates={loading}
                />
              ))
            : (
              <p className="text-sm text-gray-500">
                {error
                  ? intl.get("contaInternacional.balancesLoadError")
                  : intl.get("contaInternacional.noForeignBalances")}
              </p>
            )}
      </div>

      <div className="balance-cards-actions mt-4">
        <button
          type="button"
          className="btn-outline text-sm"
          onClick={onViewAllCurrencies}
          disabled={isInitialLoading}
        >
          {intl.get("contaInternacional.viewAllCurrencies")}
        </button>
      </div>
    </section>
  );
};
